import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderIllustration = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.6084 14.0643C4.6084 12.1755 4.6084 11.2312 4.9818 10.5123C5.29646 9.90658 5.79037 9.41267 6.39612 9.09801C7.11495 8.72461 8.05933 8.72461 9.94809 8.72461H23.8856C24.6891 8.72461 25.0908 8.72461 25.4697 8.81484C25.7918 8.89155 26.1006 9.01606 26.3858 9.18423C26.7213 9.38204 27.0107 9.6607 27.5894 10.218L27.9319 10.5478C28.5107 11.1051 28.8 11.3838 29.1355 11.5816C29.4208 11.7497 29.7296 11.8743 30.0517 11.951C30.4305 12.0412 30.8323 12.0412 31.6357 12.0412H45.7008C47.5896 12.0412 48.534 12.0412 49.2528 12.4146C49.8585 12.7293 50.3524 13.2232 50.6671 13.8289C51.0405 14.5477 51.0405 15.4921 51.0405 17.3809V49.1703C51.0405 50.1147 51.0405 50.5869 50.8538 50.9463C50.6965 51.2491 50.4495 51.4961 50.1466 51.6534C49.7872 51.8401 49.315 51.8401 48.3707 51.8401H9.41412C7.71423 51.8401 6.86429 51.8401 6.21735 51.5041C5.67217 51.2209 5.22766 50.7764 4.94446 50.2312C4.6084 49.5842 4.6084 48.7343 4.6084 47.0344V14.0643Z",
			fill: "url(#paint0_linear_198_9919)"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 1.28872,
			y: 13.7018,
			width: 62.3732,
			height: 44.7741,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(3.32px)",
					clipPath: "url(#bgblur_0_198_9919_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-figma-bg-blur-radius": 6.63316,
			d: "M21.3604 20.835H51.9482C53.286 20.835 54.235 20.8365 54.9395 20.9375C55.6304 21.0366 55.9889 21.2196 56.2236 21.5088C56.4583 21.798 56.5638 22.1865 56.5186 22.8828C56.4839 23.4155 56.3655 24.0718 56.1924 24.9189L56.002 25.832L51.3242 48.0527C51.1357 48.948 51.0025 49.5751 50.8418 50.0459C50.6855 50.5036 50.5211 50.7575 50.3018 50.9355C50.0823 51.1136 49.7995 51.2226 49.3193 51.2812C48.8256 51.3415 48.1842 51.3428 47.2695 51.3428H8.95508C9.46663 50.5859 9.79563 49.7672 10.1152 48.7246C10.3328 48.0146 10.5511 47.1859 10.8174 46.2012C11.0179 45.4596 11.2478 44.6217 11.5303 43.6621L11.8311 42.6611C12.4471 40.6513 13.4606 37.2279 14.5068 33.6641L17.3789 23.8242C17.6167 23.0062 17.7841 22.4342 17.9648 22.0059C18.1184 21.6419 18.2671 21.4205 18.4443 21.2637L18.5225 21.2002C18.7354 21.0403 19.0036 20.9421 19.4521 20.8896C19.6828 20.8627 19.9469 20.8487 20.2598 20.8418L21.3604 20.835Z",
			fill: "#94DCC8",
			fillOpacity: .6,
			stroke: "url(#paint1_linear_198_9919)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8994 12.165H19.5322C20.3797 12.165 21.0673 12.8518 21.0674 13.6992C21.0674 14.5467 20.3797 15.2334 19.5322 15.2334H12.8994C12.052 15.2334 11.3652 14.5467 11.3652 13.6992C11.3653 12.9049 11.9686 12.2516 12.7422 12.1729L12.8994 12.165Z",
			fill: "url(#paint2_linear_198_9919)",
			fillOpacity: .9,
			stroke: "url(#paint3_linear_198_9919)",
			strokeWidth: .247594
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_198_9919_clip_path",
				transform: "translate(-1.28872 -13.7018)",
				children: /* @__PURE__ */ _jsx("path", { d: "M21.3604 20.835H51.9482C53.286 20.835 54.235 20.8365 54.9395 20.9375C55.6304 21.0366 55.9889 21.2196 56.2236 21.5088C56.4583 21.798 56.5638 22.1865 56.5186 22.8828C56.4839 23.4155 56.3655 24.0718 56.1924 24.9189L56.002 25.832L51.3242 48.0527C51.1357 48.948 51.0025 49.5751 50.8418 50.0459C50.6855 50.5036 50.5211 50.7575 50.3018 50.9355C50.0823 51.1136 49.7995 51.2226 49.3193 51.2812C48.8256 51.3415 48.1842 51.3428 47.2695 51.3428H8.95508C9.46663 50.5859 9.79563 49.7672 10.1152 48.7246C10.3328 48.0146 10.5511 47.1859 10.8174 46.2012C11.0179 45.4596 11.2478 44.6217 11.5303 43.6621L11.8311 42.6611C12.4471 40.6513 13.4606 37.2279 14.5068 33.6641L17.3789 23.8242C17.6167 23.0062 17.7841 22.4342 17.9648 22.0059C18.1184 21.6419 18.2671 21.4205 18.4443 21.2637L18.5225 21.2002C18.7354 21.0403 19.0036 20.9421 19.4521 20.8896C19.6828 20.8627 19.9469 20.8487 20.2598 20.8418L21.3604 20.835Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_198_9919",
				x1: 51.0405,
				y1: 30.2824,
				x2: 4.6084,
				y2: 30.2824,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00897B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#50AE9C"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_198_9919",
				x1: 5.43444,
				y1: 22.5855,
				x2: 23.0199,
				y2: 64.9924,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: .765625,
					stopColor: "white",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_198_9919",
				x1: 10.485,
				y1: 11.8194,
				x2: 24.1027,
				y2: 15.8428,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: .4
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_198_9919",
				x1: 9.55653,
				y1: 12.7479,
				x2: 16.2161,
				y2: 15.3576,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "white",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgFolderIllustration);
export { ForwardRef as ReactComponent };
